import React from "react";
import {Card} from "antd";
import {FileType} from "../../APIModels/FileParam";
import {blobToSRC, formatDate} from "../../util/UtilFunction";
import FileService from "../../Services/fileService";
import MagazineService from "../../Services/magazineService";

export class CardEdition extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            cover: null,
            magazineList: []
        }

        this.fileService = new FileService(this.props.token);
        this.magazineService = new MagazineService(this.props.token);
        this.getFile = this.getFile.bind(this);
    }

    componentDidMount(){
        this.getFile()
        this.getMagazineList()
    }

    getFile() {
        let cover = this.props.edition.files.filter(f => f.type === FileType.Cover)[0];
        const imgId = "coverImg" + this.props.edition.number + this.props.edition.magazineId;
        const pdfId = "coverPDF" + this.props.edition.number + this.props.edition.magazineId;

        if (cover) {
            const coverIsPdf = cover.fileName.endsWith(".pdf");
            this.setState({ cover: cover})
            this.fileService.downloadFile(cover.id)
                .then(resp => {
                    let base64 = '';
                    let reader = blobToSRC(resp.data, coverIsPdf ? 'application/pdf' : 'image/jpg')
                    reader.onloadend = function () {
                        base64 = reader.result;
                        if(coverIsPdf){
                            document.getElementById(pdfId).setAttribute('src', base64 + "#toolbar=0&zoom=0")
                            document.getElementById(pdfId).style.display = 'block';
                            document.getElementById(imgId).style.display = 'none';
                        }else{
                            document.getElementById(imgId).setAttribute('src', base64);
                            document.getElementById(pdfId).style.display = 'none';
                        }
                    }
                })
        }
        else{
            document.getElementById(imgId).src = 'https://fakeimg.pl/260x260/?text=No Cover';
            document.getElementById(pdfId).style.display = 'none';
        }
    }
    
    getMagazineList = async () => {
        try {
            const response = await this.magazineService.getMagazineList({});
            const magazine = response.data.data.map(magazine => ({
                id: magazine.id,
                name: magazine.name
            }));
            this.setState({ magazineList: magazine });
        } catch (error) {
            console.error('Error fetching dropdown options:', error);
            this.setState({ errorMessage: 'Failed to fetch magazine list' });
        }
    }

    goToDetail(id) {
        window.open("/archive/edition/detail?id=" + id, "_self")
    }

    render() {
        return (
            <Card className="fmk_card p-4 text-center mt-0" style={{borderRadius: "6px", cursor: "pointer"}} onClick={() => this.goToDetail(this.props.edition.id)}>
                <img id={"coverImg" + this.props.edition.number + this.props.edition.magazineId} className="coverEdition" style={{height: 300}}/>
                <iframe id={"coverPDF" + this.props.edition.number + this.props.edition.magazineId} className="coverEdition" style={{height: 300, display:"none"}} frameBorder="0"></iframe>
                <span className="mt-2 d-block text-left">
                    Edition n° <span className="fakeLink">{this.props.edition.number}</span>
                    {this.props.edition.parentEditionAttachmentType && (
                        <span className="ml-2">({this.props.edition.parentEditionAttachmentType.number})</span>
                    )}
                </span>
                <p className="m-0 text-left small">
                    <strong>
                        {(() => {
                            const magazine = this.state.magazineList.find(mag => mag.id === this.props.edition.magazineId);
                            return magazine ? magazine.name : 'Unknown Magazine';
                        })()}
                    </strong>
                </p>
                <p className="m-0 text-left">
                    <strong>{formatDate(this.props.edition.competenceDateFrom, 'MM/YYYY')} - {formatDate(this.props.edition.competenceDateTo, 'MM/YYYY')}</strong>
                </p>
            </Card>
        )
    }

}



// WEBPACK FOOTER //
// ./src/FileMaker/Editions/CardEdition.js